export const SUBMIT_COS_ANNEXE_TR_FORM = 'cosAnnexeTRForm/SUBMIT_COS_ANNEXE_TR_FORM';
